import * as React from 'react';
import {connect} from 'react-redux';
import {ImageAsBackground, Icon, ClassNameBuilder} from '@openfin/desktop-ui';

import {RootState} from '../../../store/State';
import {CloseButton} from '../CloseButton/CloseButton';
import {DockedDependent} from '../../utils/DockedDependent';
import {BookendControls} from '../BookendControls/BookendControls';
import {LaunchBarSize} from '../../utils/constants';
import * as OpenfinLogo from '../../../assets/OpenFinLaunchBarIcon.svg';
import {isOmnibar} from '../../../utils/processHelpers';

import * as Styles from './Header.module.scss';

interface Props {
    title?: string;
    docked: boolean;
    logo: string;
    icon: string;
    children?: React.ReactNode;
    onClose: () => void;
    size: LaunchBarSize;
}

const HeaderComponent: React.FC<Props> = (props) => {
    const {children, title, size, icon, onClose, docked, logo} = props;
    const detailsClassNames = new ClassNameBuilder(Styles, 'details')
        .add(['floating', !docked])
        .add(['collapsed', size === LaunchBarSize.COLLAPSED]);

    const headerClassNames = new ClassNameBuilder(Styles, 'header')
        .add(['omnibar', isOmnibar()])
        .add(['expanded', size === LaunchBarSize.EXPANDED])
        .toString();

    return (
        <DockedDependent docked={isOmnibar() ? true : undefined}>
            <div className={headerClassNames}>
                {isOmnibar() && <ImageAsBackground src={logo} className={Styles['logo']} />}
                <div className={detailsClassNames.toString()}>
                    <Icon className={Styles['icon']} src={icon} />
                    {!children && <span className={Styles['title']}>{title}</span>}
                    {children}
                </div>
                {!isOmnibar() && <div className={Styles['actions']}>
                    <CloseButton onClick={onClose} />
                </div>}
                {isOmnibar() && <BookendControls />}
            </div>
        </DockedDependent>
    );
};

const mapState = (state: RootState, ownProps: Partial<Props>) => ({
    logo: state.organization.logo || OpenfinLogo,
    size: ownProps.size !== undefined ? ownProps.size : state.launchBar.size,
    docked: ownProps.docked !== undefined ? ownProps.docked : state.settings.launcherDocked
});

export const Header = connect(mapState)(HeaderComponent);
